/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-01-14 11:55:14
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-08-25 10:45:03
 * @Description: file content
 * audio控制中心
 * 用法：
 * $audio.add(name,src); 添加音乐
 * $audio[name].play(options = null, callback); 播放音乐。默认：循环播放。
 * $audio[name].pause(callback); 暂停音乐
 * $audio[name].ended(callback); 播放结束回调
 * $audio[name].getIsPlay(); 获取是否在播放
 */
import wx from "@/services/act-wxjssdk";
let audioList = [];
wx.ready(() => {
  for (let index = 0; index < 100; index++) {
    audioList.push(new Audio());
  }
});

function getAudioFromAudioList() {
  let findAudio = null;
  for (let index = 0; index < audioList.length; index++) {
    const element = audioList[index];
    if (!element.src) {
      findAudio = element;
    }
  }
  return findAudio || null;
}

function CheckIsAndroid() {
  var browser = {
    versions: function () {
      var u = navigator.userAgent, app = navigator.appVersion;
      return { //移动终端浏览器版本信息
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器 //u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
      };
    }(),
  }
  //if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
  //    return false;
  //}
  if (browser.versions.android)
    return true;
  return false;
}
function MyAudio1(name, url) {
  this.name = name
  this.audioContext = new (window.AudioContext || window.webkitAudioContext || window.mozAudioContext)();
  this.sourceNode = null;
  this.buffer = null;
  this.isPlayingBGM = false;
  // 获取是否在播放状态
  this.getIsPlay = () => {
    return !this.isPlayingBGM;
  }
  //  暂停回调
  this.pause = (callback) => {
    if (this.audioContext && this.sourceNode?.buffer) {
      this.sourceNode.stop();
      this.isPlayingBGM = false;
      if (callback) {
        callback();
      }
    } else {
      console.warn(`${name}没有audio文件！`);
    }
  }
  this.play = (options, callback) => {
    if (this.buffer === null) {
      let tmpInterval = setInterval(() => {
        if (this.buffer != null) {
          console.log(`$audio ${this.name} play 音频已就绪 开始播放`);
          this.play(options, callback);
          clearInterval(tmpInterval);
        }
      }, 100);
    } else {
      console.log(`$audio ${this.name} play`, this);
      const audioContext = this.audioContext;
      audioContext.resume();
      const _sourceNode = audioContext.createBufferSource();
      _sourceNode.buffer = this.buffer;
      _sourceNode.loop = true;
      Object.assign(_sourceNode, options)
      _sourceNode.connect(audioContext.destination);
      this.sourceNode = _sourceNode;
      this.sourceNode.start(0);
      this.isPlayingBGM = true;
      if (callback) {
        callback();
      }
    }

  }
  let loadAndAutoPlay = (audioUrl) => {
    const audioContext = this.audioContext;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', audioUrl, true);
    xhr.responseType = 'arraybuffer';
    xhr.onreadystatechange = () => {
      if (xhr.status < 400 && xhr.status >= 200 && xhr.readyState === 4) {
        audioContext.decodeAudioData(xhr.response, buffer => {
          this.buffer = buffer;
        });
      }
    }
    xhr.send();
  }
  loadAndAutoPlay(url)
}
class MyAudio {
  constructor(name, src) {
    this.name = name;
    this.audio = getAudioFromAudioList();
    if (this.audio) {
      this.audio.preload = "auto";
      this.audio.src = src;
    } else {
      console.warn("audioList数量不足！");
    }
    this.isManualClose = false;
  }

  // 播放配置参数、回调
  play(options = null, callback) {
    if (this.audio && this.audio.src) {
      console.log(`$audio ${this.name} play`, this);
      if (callback) {
        this.audio.addEventListener("playing", () => {
          console.log(`$audio ${this.name} playing 执行回调函数`);
          callback();
        });
      }
      this.audio.loop = true;
      Object.assign(this.audio, options);
      /**
       * readyState返回音频当前的就绪状态。
       * 0 = HAVE_NOTHING - 没有关于音频是否就绪的信息， 微信环境下大于0 即可
        1 = HAVE_METADATA - 关于音频就绪的元数据
        2 = HAVE_CURRENT_DATA - 关于当前播放位置的数据是可用的，但没有足够的数据来播放下一帧/毫秒
        3 = HAVE_FUTURE_DATA - 当前及至少下一帧的数据是可用的
        4 = HAVE_ENOUGH_DATA - 可用数据足以开始播放
       */
      if (this.audio.readyState > 0) {
        this.audio.play();
      } else {
        // 等待加载
        console.log(`$audio ${this.name} play 等待音频就绪`);
        let tmpInterval = setInterval(() => {
          if (this.audio.readyState > 0) {
            console.log(`$audio ${this.name} play 音频已就绪 开始播放`);
            this.audio.play();
            clearInterval(tmpInterval);
          }
        }, 100);
      }
    } else {
      console.warn(`${name}没有audio文件！`);
    }
  }
  //  暂停回调
  pause(callback) {
    if (this.audio && this.audio.src) {
      if (callback) {
        this.audio.addEventListener("pause", () => {
          console.log(`$audio ${this.name} pause 执行回调函数`);
          callback();
        });
      }
      this.audio.pause();
    } else {
      console.warn(`${name}没有audio文件！`);
    }
  }
  // 播放结束回调
  ended(callback) {
    if (this.audio && this.audio.src) {
      if (callback) {
        this.audio.addEventListener("ended", function () {
          console.log(`$audio ${this.name} ended 执行回调函数`);
          callback();
        });
      }
    } else {
      console.warn(`${name}没有audio文件！`);
    }
  }
  // 获取是否在播放状态
  getIsPlay() {
    return this.audio && this.audio.paused;
  }
}

let audioControl = {
  list: [],
  isFirst: true,
  // 添加 音乐名字和路径  $audio[name] 来使用，方法在MyAudio类上
  add: function (name, src) {
    // 检测此name有没有在myAudioList
    let existAudio = null;
    for (let index = 0; index < this.list.length; index++) {
      const element = this.list[index];
      if (element.name == name) {
        existAudio = element;
      }
    }
    if (existAudio) {
      // 修改
      existAudio.src = src;
      console.log(`$audio add ${name} 仅修改路径为 ${src};`, this.list);
      this.isFirst = false
    } else {
      // 添加
      let myAudioObj = null
      if (CheckIsAndroid()) {
        myAudioObj = new MyAudio1(name, src);
      } else {
        myAudioObj = new MyAudio(name, src);
      }
      this.list.push(myAudioObj);
      this[name] = myAudioObj;
      console.log(`$audio add ${name} 路径为 ${src};`, this.list);
    }
  },
};

let plugin = {};
plugin.install = function (Vue) {
  Vue.prototype.$audio = audioControl;
};
export default plugin;
